(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('ksc-ko-extenders', ['knockout'], factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node/CommonJS
        module.exports = function( root, ko ) {
            if ( ko === undefined ) {
                if ( typeof window !== 'undefined' ) {
                    ko = require('knockout');
                }
                else {
                    ko = require('knockout')(root);
                }
            }
            factory(ko);
        };
    } else {
        // Browser globals
        factory(ko);
    }
}(function (ko) {
    "use strict";

    /**
     *
     * @param {number} [throttleTime]
     * @param {Function} subscriber
     */
    ko.subscribable.fn.throttledSubscribe = function throttledSubscribe(throttleTime, subscriber) {
        var subscriberFn = subscriber;
        var throttleInterval = throttleTime;
        if (!subscriber) {
            subscriberFn = throttleTime;
            throttleInterval = 1;
        }

        var target = this;

        var updating = false;
        target.disregardNextUpdate = function () {
            updating = true;
        };
        target.updateWithoutNotifyingSubscriber = function (value) {
            if (target() === value) {
                return;
            }
            updating = true;
            target(value);
        };

        var throttledComputed = ko.computed(target).extend({ throttle: throttleInterval });

        throttledComputed.subscribe(function (value) {
            if (updating === false) {
                subscriberFn(value);
            } else {
                updating = false;
            }
        });
    };
}));


